module.exports = __webpack_public_path__ + "static/pure-icon-325910c6d00535c588af694faa6a611a.svg";